import { Map, List, Set } from "immutable";

export const isMapEmpty = data => !Map.isMap(data) || data.isEmpty();

export const isListEmpty = data => !List.isList(data) || data.isEmpty();

export const isSetEmpty = data => !Set.isSet(data) || data.isEmpty();

export default {};